import PropTypes from 'prop-types';
import { Button } from 'antd';
import SurveyFieldInput from './SurveyFieldInput';
import styles from '../../styles/personal-survey.module.scss';

const RepeatableConditionsField = ({ itemFields, value, onChange }) => {
  const rows = Array.isArray(value) ? value : [];

  const updateRow = (index, key, itemValue) => {
    const next = rows.map((row, i) => (i === index ? { ...row, [key]: itemValue } : row));
    onChange(next);
  };

  const removeRow = (index) => {
    onChange(rows.filter((_, i) => i !== index));
  };

  const addRow = () => {
    const emptyRow = {};
    itemFields.forEach((f) => {
      emptyRow[f.key] = f.type === 'text' ? '' : undefined;
    });
    onChange([...rows, emptyRow]);
  };

  return (
    <div className={styles.repeatable}>
      {rows.map((row, index) => (
        <div className={styles.repeatable__row} key={index}>
          <div className={styles.repeatable__rowFields}>
            {itemFields.map((itemField) => (
              <div className={styles.repeatable__rowField} key={itemField.key}>
                <SurveyFieldInput
                  field={itemField}
                  value={row[itemField.key]}
                  onChange={(v) => updateRow(index, itemField.key, v)}
                />
              </div>
            ))}
          </div>
          <Button
            type="text"
            className={styles.repeatable__remove}
            onClick={() => removeRow(index)}
            icon={<img src="/assets/icons/delete.svg" alt="Ukloni" />}
            aria-label="Ukloni"
          />
        </div>
      ))}
      <Button className={`btn-tertiary btn-small ${styles.repeatable__add}`} onClick={addRow}>
        Dodaj stanje
      </Button>
    </div>
  );
};

RepeatableConditionsField.propTypes = {
  itemFields: PropTypes.array.isRequired,
  value: PropTypes.array,
  onChange: PropTypes.func.isRequired,
};

export default RepeatableConditionsField;
